import { render, staticRenderFns } from "./PerseuInputFileAWS.vue?vue&type=template&id=630e4278"
import script from "./PerseuInputFileAWS.vue?vue&type=script&lang=js"
export * from "./PerseuInputFileAWS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports